const COLLECTION_KEYS = [
  'data',
  'content',
  'items',
  'records',
  'results',
  'result',
  'applications',
  'list',
  'rows',
  'values',
  'entries',
  'payload',
  'page',
  'response',
]

export function isObjectLike(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

function findArrayInPayload(value: unknown, seen: Set<unknown>): unknown[] | null {
  if (Array.isArray(value)) {
    return value
  }

  if (!isObjectLike(value) || seen.has(value)) {
    return null
  }

  seen.add(value)

  const record = value as Record<string, unknown>

  for (const key of COLLECTION_KEYS) {
    if (key in record) {
      const nested = record[key]
      const result = findArrayInPayload(nested, seen)
      if (result) {
        return result
      }
    }
  }

  for (const nested of Object.values(record)) {
    const result = findArrayInPayload(nested, seen)
    if (result) {
      return result
    }
  }

  return null
}

function unwrapApiPayloadInternal(value: unknown, seen: Set<object>): unknown {
  if (!isObjectLike(value) || Array.isArray(value)) {
    return value
  }

  const record = value as Record<string, unknown>

  if (seen.has(record)) {
    return value
  }

  seen.add(record)

  for (const key of COLLECTION_KEYS) {
    if (key in record) {
      const nested = record[key]
      if (nested !== undefined) {
        return unwrapApiPayloadInternal(nested, seen)
      }
    }
  }

  return value
}

export function extractApiPayload(payload: unknown): unknown {
  const arrayPayload = findArrayInPayload(payload, new Set<unknown>())
  if (arrayPayload) {
    return arrayPayload
  }

  return unwrapApiPayloadInternal(payload, new Set<object>())
}

export function mapApiListResponse<T>(payload: unknown, mapItem: (item: unknown) => T): T[] {
  const resolved = extractApiPayload(payload)

  if (Array.isArray(resolved)) {
    return resolved.map(mapItem)
  }

  return []
}
